import * as yup from 'yup'

class Truck {
  _id = ''
  abbreviation = ''
  color = ''
  hasLift = false
  inService = true
  name = ''
  branchId = ''
  isRental = false
  rentalDay?: string
}

const validTruckName = /^[a-zA-Z0-9_]{2,20}$/

const TruckValidationSchema = yup.object().shape({
  _id: yup.string().matches(/^[a-f\d]{24}$/i, { excludeEmptyString: true }),
  abbreviation: yup.string().min(2).required(),
  color: yup.string().required(),
  hasLift: yup.boolean(),
  inService: yup.boolean(),
  name: yup
    .string()
    .matches(
      /^[a-zA-Z0-9_]{2,20}$/,
      'Truck names may only contain letters, numbers, and underscore. Truck names must be between 2 and 20 characters.',
    )
    .required(),
  branchId: yup
    .string()
    .matches(/^[a-f\d]{24}$/i)
    .required(),
  isRental: yup.boolean(),
  rentalDay: yup
    .string()
    .when('isRental', {
      is: true,
      then: (schema: any) => schema().matches(/^\d{4}-[01]?\d-[0-3]?\d$/),
    })
    .nullable(),
})

class TruckSet {
  count = 0
  page = 0
  size = 0
  total = 0
  trucks: Truck[] = []
}

export { Truck, TruckSet, TruckValidationSchema, validTruckName }
